import clearKnock from '@shoflo/studio-redux/actions/knock/clearKnock';
import { DENIED } from 'constants/KnockTypes';

export default async function rejectedKnockHandler() {
  const { knocks } = this.store.getState();

  const rejectedKnocks = knocks.filter(filterByStatus);

  //Check to see if there are acceptedKnocks
  if (rejectedKnocks.length === 0) return;

  //Only process the first one (others will processed after state is mutated again)
  const firstRejectedKnock = rejectedKnocks[0];

  //Clear the knock from state
  this.store.dispatch(clearKnock(firstRejectedKnock));

  //Send the meeting and attendee info over the socket
  this.socket.emit('knockReject', {
    broadcastId: firstRejectedKnock.broadcastId,
    socketId: firstRejectedKnock.socketId,
    knockId: firstRejectedKnock?._id
  });
}

function filterByStatus(kn) {
  return kn.status === DENIED;
}
